@if (isReportingActive && !appState.isHistoryEnabled()) {
  <div
    class="position-absolute top-0 start-0 end-0 z-5"
    data-cy="reporting-mode-indicator"
    style="height: 5px; background-color: #ff6600; pointer-events: none"
  ></div>
}
